import {
  setGetAuthTokenModule,
  setRefreshTokensModule,
} from '@quickmd-llc/frontend-utils';
import { getAccessToken } from './utils';
import { useApplicationStore } from '@data';
import { postAuthRefreshtokenV2 } from './generated/auth-v2/auth-v2';

const refreshTokens = async () => {
  try {
    const {
      // refresh tokens are unnecessary in api/v2 (stytch). they can be ignored. access token is all that is necessary
      auth: { accessToken, setAccessToken },
    } = useApplicationStore.getState();
    if (!accessToken) {
      return false;
    }

    const data = await postAuthRefreshtokenV2({ AccessToken: accessToken });

    if (!data.AccessToken) return false;
    setAccessToken(accessToken);
    return true;
  } catch {
    return false;
  }
};

export function initOrvalTokenModules() {
  setGetAuthTokenModule(getAccessToken);
  setRefreshTokensModule(refreshTokens);
}
